import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { X } from '@/lib/socialProfile';

import { LineChart } from '@/components/composite/Charts/LineChart';

export const repostsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.twitter.reposts_history',
    tooltip: 'chart.twitter.reposts_history_tooltip',
    id: 'reposts_history',
    margin: { left: -30, bottom: 25, right: 10 },
    name: {
        date: 'date',
        value: 'chart.twitter.reposts_history_name'
    },
    social: X,
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    isXAxisDate: true,
    element: LineChart
};
